module.exports = __webpack_public_path__ + "img/1-10.68c2eb45.webp";